// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, HasOnError, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateShipTo as updateShipToApi } from "@insite/client-framework/Services/CustomersService";
import {
    chain,
    DispatchCompleteLoadShipTo,
    SendDataToApi,
} from "@insite/client-framework/Store/Data/ShipTos/Handlers/UpdateShipTo";

// XNG-Changes: FLIP-892 This handler being used to handle Create Ship to errors 
export const xSendDataToApi: typeof SendDataToApi = async (props: any) => {
    try {
        props.apiResult = await updateShipToApi(props.apiParameter);
        props.error = "";
    } catch (error) {
        props.error = (error as any)?.errorMessage;
    }
};

export const excuteOnError = (props: any) => {
    if (props.error) {
        props.parameter.onError(props.error);
    }
};

export const xDispatchCompleteLoadShipTo = (props: any) => {
    if (props.error) {
        return;
    }
    DispatchCompleteLoadShipTo(props);
};

replaceInChain(chain, SendDataToApi, xSendDataToApi);
addToChainBefore(chain, DispatchCompleteLoadShipTo, excuteOnError);
replaceInChain(chain, DispatchCompleteLoadShipTo, xDispatchCompleteLoadShipTo);
